import { styled } from '@mui/material/styles';
import InputSelect from 'src/components/shared/Form/Select';
import ButtonComponent from 'src/components/shared/Button';
import theme, { mobileTypography, palette, shadows } from 'src/config/theme';
import { alpha, Avatar, Box, Chip, Typography } from '@mui/material';

export const Container1 = styled(Box)({
  width: '100%',
  height: '44px',
  display: 'grid',
  gridTemplateColumns: '1fr',
  [theme.breakpoints.up('sm')]: {
    display: 'grid',
    gridTemplateColumns: '1fr',
  },
});

export const AddAppointment = styled(ButtonComponent)({
  minWidth: '168px',
  height: '44px',
  backgroundColor: palette.primary.main,
  border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
  borderRadius: '8px',
  padding: '10px 12px',
  boxShadow: shadows[1],
  color: palette.gery.white,
  '&:hover': {
    color: theme.palette.primary.main,
  },
});

export const Container2 = styled(Box)({
  height: 'calc(100vh - 80px)',
  overflow: 'hidden',
  width: '100%',
  marginTop: '20px',
  marginBottom: '50px',
  display: 'flex',
  flexDirection: 'column',
});
export const InnerAppointments = styled(Box)({
  flex: 1,
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  justifyContent: 'space-between',
  scrollbarWidth: 'none', // Firefox
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(palette.primary.main, 0.5),
    borderRadius: '8px',
  },

});
export const InnerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEmpty'
})(({ isEmpty }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: isEmpty ? '0px' : '16px',
  justifyContent: isEmpty ? 'center' : 'flex-start',
  alignItems: isEmpty ? 'center' : 'stretch',
  height: isEmpty ? '100%' : 'auto',
  [theme.breakpoints.up('sm')]: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  },
}));


export const BoxContainer = styled(Box)({
  width: '100%',
  backgroundColor: palette.gery.white,
  display: 'flex',
  flexDirection: 'column',
  // gap: '16px',
  border: `1px solid ${palette.primary.light1}`,
  boxShadow: shadows[1],
  // height: 'auto',
  borderRadius: '12px',
  // minWidth: '350px',


});
export const BoxInner1 = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px',
});
export const DataContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});
export const Text = styled(Typography)({
  ...mobileTypography.h6,
  color: palette.gery.black,
});

export const ReportText = styled(Typography)({
  ...mobileTypography.h6,
  textDecoration: 'underline',
  textDecorationColor: `${palette.primary.main}`,
  textDecorationThickness: '1.2px',
  textUnderlineOffset: '3px',
  color: palette.primary.main
});

export const Text2 = styled(Typography)({
  ...mobileTypography.small,
  color: palette.gery.black,
});
export const Texts = styled(Typography)({
  ...mobileTypography.body2,
  color: `${alpha(palette.gery.black, 0.7)}`,
});
export const StatusData = styled(Box)({
  width: 'auto',
  height: '40px',
  borderRadius: '100px',
  // padding: '8px 18px',
  // background: 'linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))',
  // color: theme.palette.action.purpleDark,
  ...mobileTypography.small,
});
export const LineContainer = styled(Box)({
  width: '100%',
  border: `1px solid ${alpha(palette.gery.black, 0.1)}`,
});
export const MenuContainer = styled(Avatar)({
  width: '40px',
  height: '40px',
  backgroundColor: palette.primary.light4,
  color: palette.primary.main,
  cursor: 'pointer',
});

export const PaymentContainer = styled(Box)({
  display: 'flex',
  gap: '6px',
  flexDirection: 'row',
  alignItems: 'center'
})
export const Dot = styled(Box)({
  width: '5px',
  height: '5px',
  backgroundColor: palette.gery.lightGray
})
export const TreatmentStatus = styled(Chip)({

  background: 'rgba(103, 57, 150, 0.14)',
  color: theme.palette.action.purpleLight,
  cursor: 'pointer',

  borderRadius: '100px',
  padding: '8px 18px',
  ...mobileTypography.small,
})
export const PagingContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '50px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  borderRadius: '0px 0px 6px 6px',
  border: `1px solid ${palette.primary.light2}`,
  backgroundColor: palette.gery.white,
})


